import { LineType } from '../../drawing/types';
import { LineStyle } from './ui';
import FreehandPenUIAction from '../../actions/ui/FreehandPenUIAction';
import { Color } from '../../types/color';
import { FreehandPenWidth } from '../../types/freehandPenWidth';

interface FreehandPenToolState {
  color: Color;
  width: FreehandPenWidth;
  lineType: LineType;
  lineStyle: LineStyle;
}

export interface FreehandPenState {
  toolSettings: FreehandPenToolState[];
  selected: number;
}

export function initFreehandPenUIState(): FreehandPenState {
  return {
    toolSettings: [{
      color: Color.Black,
      width: FreehandPenWidth.one,
      lineType: LineType.Solid,
      lineStyle: LineStyle.Freehand,
    }, {
      color: Color.Black,
      width: FreehandPenWidth.one,
      lineType: LineType.Solid,
      lineStyle: LineStyle.Freehand,
    }, {
      color: Color.Black,
      width: FreehandPenWidth.one,
      lineType: LineType.Solid,
      lineStyle: LineStyle.Freehand,
    }, {
      color: Color.Black,
      width: FreehandPenWidth.one,
      lineType: LineType.Solid,
      lineStyle: LineStyle.Freehand,
    }],
    selected: 0,
  };
}

export const freehandPen = (
  state: FreehandPenState,
  action: FreehandPenUIAction.Action,
): FreehandPenState => {
  switch (action.type) {
    case FreehandPenUIAction.ActionType.SELECT_TOOL: {
      return { ...state, selected: action.selected };
    }
    case FreehandPenUIAction.ActionType.SET_PEN_COLOR: {
      const newToolSettings = [...state.toolSettings];
      newToolSettings[action.selected].color = action.color;

      return { ...state, toolSettings: newToolSettings };
    }
    case FreehandPenUIAction.ActionType.SET_PEN_WIDTH: {
      const newToolSettings = [...state.toolSettings];
      newToolSettings[action.selected].width = action.width;

      return { ...state, toolSettings: newToolSettings };
    }
    case FreehandPenUIAction.ActionType.SET_LINE_TYPE: {
      const newToolSettings = [...state.toolSettings];
      newToolSettings[action.selected].lineType = action.lineType;

      return { ...state, toolSettings: newToolSettings };
    }
    case FreehandPenUIAction.ActionType.SET_LINE_STYLE: {
      const newToolSettings = [...state.toolSettings];
      newToolSettings[action.selected].lineStyle = action.lineStyle;

      return { ...state, toolSettings: newToolSettings };
    }
  }
};
